import { useCheckoutStore } from "@/store/checkout";
import { useDatalayerStore } from "@/store/datalayer";
import { useClientStore } from "@/store/client";
import { useMagasinStore } from "@/store/magasin";
import { usePanierStore } from "@/store/panier";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const pageCommanderEmits = () => ([
  "setRedirect"
])

export const usePageCommander = (context, popinAlerteMagasinRef) => {
  const datalayerStore = useDatalayerStore();
  const checkoutStore = useCheckoutStore();
  const panierStore = usePanierStore();
  const magasinStore = useMagasinStore();
  const clientStore = useClientStore();

  const { trackEvent } = useInteractionDoneTracking();

  const router = useRouter();

  const isChangeMagasinLoading = ref(false);

  const {
    name: magasinName,
    modesCommande,
    isEligibleAbonnementLad,
    montantMinimumLAD,
    id: magasinId,
    isDispoCarrefour,
    jourDispoPremierCreneauCarrefour,
    magasin
  } = storeToRefs(magasinStore);

  const {
    storeLocatorContext,
    shippingMode
  } = storeToRefs(datalayerStore);

  const {
    isPremiereCommande,
    isMagasinInhabituel,
    warning,
    typePanier,
    modesCommandes
  } = storeToRefs(checkoutStore);

  const {
    hasAbonnement: hasAbonnementInPanier,
    montantSansAbonnement
  } = storeToRefs(panierStore);

  const {
    aboLadMaxAtteint,
    abonnements,
    abonnementExpireInMagasin
  } = storeToRefs(clientStore);

  const {
    setStoreLocatorContext
  } = datalayerStore;

  const {
    createListeFromPanier,
    clear
  } = panierStore;

  const {
    resetWarning
  } = checkoutStore;


  const abonnementInCurrentMagasin = computed(() => {
    return abonnements.value.find(abo => abo.attributes.magasin_id === magasinId.value) || null
  })
  const abonnementExpireInCurrentMagasin = computed(() => {
    return abonnementExpireInMagasin.value(magasinId.value)
  })
  const montantManquantLAD = computed(() => {
    return (montantMinimumLAD.value === null) ? null : montantMinimumLAD.value - montantSansAbonnement.value
  })
  const showAbonnementLadBanniere = computed(() => {
    if (modesCommandes.value) {
      return isEligibleAbonnementLad.value && !(abonnementInCurrentMagasin.value || hasAbonnementInPanier.value || aboLadMaxAtteint.value || shippingMode.value === "LAD" || modesCommandes.value.infos.LAD.tarif_mini < 8.9)
    } else {
      return isEligibleAbonnementLad.value && !(abonnementInCurrentMagasin.value || hasAbonnementInPanier.value || aboLadMaxAtteint.value || shippingMode.value === "LAD")
    }
  })
  const showAbonnementLadBanniereRenouvellement = computed(() => {
    return showAbonnementLadBanniere.value && abonnementExpireInCurrentMagasin.value;
  })

  const hidePopinAlerteMagasin = () => {
    popinAlerteMagasinRef.value.hide();
  }
  const changeMagasin = async (idMagasin) => {
    setStoreLocatorContext('commander')
    trackEvent({
      categoryGA: trackingCodes.CATEGORYGA.chooseShop,
      labelGA: storeLocatorContext.value
    });
    isChangeMagasinLoading.value = true;
    try {
      await createListeFromPanier({ titre: 'Panier Sauvegardé', typePanier: typePanier.value });
      await clear();
    } catch (err) { }
    setTimeout(async () => {
      popinAlerteMagasinRef.value.hide();
      isChangeMagasinLoading.value = false;
      navigateToInternal('/?magasin_id=' + idMagasin, { replace: true });
      router.go();
    }, 2000);
  }
  const alerteConfirmationHidden = () => {
    if (isPremiereCommande.value) {
      resetWarning("premiere_commande");
    }
    if (isMagasinInhabituel.value) {
      resetWarning("magasin_inhabituel");
    }
  }
  const setRedirect = (route) => {
    context.emit("setRedirect", route);
  }

  return {
    magasin,
    isChangeMagasinLoading,
    magasinName,
    modesCommande,
    isEligibleAbonnementLad,
    montantMinimumLAD,
    magasinId,
    storeLocatorContext,
    shippingMode,
    isPremiereCommande,
    isMagasinInhabituel,
    warning,
    typePanier,
    modesCommandes,
    hasAbonnementInPanier,
    montantSansAbonnement,
    aboLadMaxAtteint,
    abonnements,
    abonnementExpireInMagasin,
    setStoreLocatorContext,
    createListeFromPanier,
    clear,
    resetWarning,
    abonnementInCurrentMagasin,
    abonnementExpireInCurrentMagasin,
    montantManquantLAD,
    showAbonnementLadBanniere,
    showAbonnementLadBanniereRenouvellement,
    hidePopinAlerteMagasin,
    changeMagasin,
    alerteConfirmationHidden,
    setRedirect,
    isDispoCarrefour,
    jourDispoPremierCreneauCarrefour,
  }
}
